export default "__VITE_ASSET__ur3cYMy$__"